export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "keys.worker.750d8069eb011baa0104.worker.js");
}
